// import * as firebase from 'firebase/app';
// import 'firebase/firestore';
// import 'firebase/storage';
import {
    getFirestore,
    getCloudStorage,
    getGeoPoint,
    getArrayUnion,
    getArrayRemove,
    getFirebaseAuth,
    getFirestoreDeleteField,
    getCloudFunctions,
    getFirestoreIncrementField,
} from '../../system/firebase';
// import { utcToZonedTime } from 'date-fns-tz';

import { USER_TYPE_EMP } from '../constants';
// import { SNACK_BAR_MESSAGE_SAVED, SNACK_BAR_MESSAGE_CONFIRMED, INTERVIEW_STATUS_CONFIRMED } from '../constants';
// import { mapDefinedFields } from '../dtoHelper';
import { convertFirebaseTimestampsToDate } from '../dateHelper';
// import { checkEsToken, getElasticSearchSyncPostFetch } from './appServices';
import { ELASTICSEARCH_SYNC_API_URL } from '../elasticSearchHelper';
import {
    mapEmpJobsDataToElasticSearchJson,
    mapJobsDataToElasticSearchJson,
    mapJsAppliedJobsDataToElasticSearchJson,
    mapJsSavedJobsDataToElasticSearchJson,
    mapProfilesDataToElasticSearchJson,
    mapProfilesEmpDataToElasticSearchJson,
    mapThreadMessagesDataToElasticSearchJson,
    mapThreadSummariesDataToElasticSearchJson,
} from '../elasticSearchHelper';
import { nanoid } from '../nanoidHelper';
import { convertFileSize } from '../fileHelper';

import { parse as parseDt, addMonths, addDays, isAfter, format } from 'date-fns';
import voucherCodeGenerator from 'voucher-code-generator';

import _get from 'lodash/get';
import _set from 'lodash/set';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import _filter from 'lodash/filter';
import _toLower from 'lodash/toLower';
import _toNumber from 'lodash/toNumber';
import _replace from 'lodash/replace';
import _concat from 'lodash/concat';
import _isNil from 'lodash/isNil';
import _remove from 'lodash/remove';
import _find from 'lodash/find';
import _union from 'lodash/union';
// import _omit from 'lodash/omit';
import _size from 'lodash/size';
import { getFullNameByUser } from '../textHelper';
import { mapDefinedFields } from '../dtoHelper';
import { CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH } from '../../system/constants';
// import _slice from 'lodash/slice';

export const saveInterviewList = (interviewListJsonStr, setSnackbarMessage) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    // const interviewRef = db.collection('interviews');
    const interviewList = JSON.parse(interviewListJsonStr);
    _forEach(interviewList, data => {
        const interviewStartDate = _get(data, 'interviewStartDate', '08/08/2020');
        const interviewStartTime = _get(data, 'interviewStartTime', '13:00');
        const interviewEndDate = _get(data, 'interviewEndDate', '08/08/2020');
        const interviewEndTime = _get(data, 'interviewEndTime', '13:00');
        const startDt = parseDt(`${interviewStartDate} ${interviewStartTime}:00.0`, 'MM/dd/yyyy HHmm:ss.S', new Date());
        const endDt = parseDt(`${interviewEndDate} ${interviewEndTime}:00.0`, 'MM/dd/yyyy HHmm:ss.S', new Date());
        const dto = {
            companyName: _get(data, 'companyName'),
            jobTitle: _get(data, 'jobTitle'),
            pocName: _get(data, 'pocName'),
            startDt: startDt, //firebase.firestore.Timestamp.fromDate(startDt),
            endDt: endDt, //firebase.firestore.Timestamp.fromDate(endDt),
            virtual: _get(data, 'virtual'),
            jobSeekerId: _get(data, 'jobSeekerId'),
            jobSeekerName: _get(data, 'jobSeekerName'),
            status: _get(data, 'status'),
            streetAddress1: _get(data, 'streetAddress1'),
            streetAddress2: _get(data, 'streetAddress2'),
            city: _get(data, 'city'),
            state: _get(data, 'state'),
            postalCode: _get(data, 'postalCode'),
        };
        db.collection('interviews')
            .add(dto)
            .then(() => {
                setSnackbarMessage('Records added');
            })
            .catch(error => {
                console.log('Transaction failed: ', error);
            });
    });
};

export const saveMyMessagesThreads = (myMessagesJsonStr, setSnackbarMessage) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    const myMessagesJson = JSON.parse(myMessagesJsonStr);
    const { messages = [], myMessages } = myMessagesJson;
    let messagesDto = [];

    _forEach(messages, data => {
        const createDate = _get(data, 'createDate', '08/08/2020');
        const createTime = _get(data, 'createTime', '13:00');
        // const interviewEndDate = _get(data, 'interviewEndDate', '08/08/2020');
        // const interviewEndTime = _get(data, 'interviewEndTime', '13:00');
        const createDt = parseDt(`${createDate} ${createTime}:00.0`, 'MM/dd/yyyy HHmm:ss.S', new Date());
        // const endDt = parseDt(`${interviewEndDate} ${interviewEndTime}:00.0`, 'MM/dd/yyyy HHmm:ss.S', new Date());
        messagesDto.push({
            createDt: createDt, //firebase.firestore.Timestamp.fromDate(createDt),
            jobSeekerId: _get(data, 'jobSeekerId', ''),
            employerId: _get(data, 'employerId', ''),
            content: _get(data, 'content'),
        });
    });
    const dto = {
        messages: messagesDto,
    };
    db.collection('threads')
        .add(dto)
        .then(docRef => {
            setSnackbarMessage('Records added');

            saveMyMessages(docRef.id, myMessages, setSnackbarMessage);
        })
        .catch(error => {
            console.log('Transaction failed: ', error);
        });
};

export const saveMyMessages = (threadId, myMessagesJson, setSnackbarMessage) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    const { threadSummaries } = myMessagesJson;
    let threadSummariesDto = [];

    _forEach(threadSummaries, data => {
        const jobSeekerLastReadDate = _get(data, 'jobSeekerLastReadDate', '08/08/2020');
        const jobSeekerLastReadTime = _get(data, 'jobSeekerLastReadTime', '13:00');
        const lastMessageDate = _get(data, 'lastMessageDate', '08/08/2020');
        const lastMessageTime = _get(data, 'lastMessageTime', '13:00');
        const jobSeekerLastReadDt = parseDt(`${jobSeekerLastReadDate} ${jobSeekerLastReadTime}:00.0`, 'MM/dd/yyyy HHmm:ss.S', new Date());
        const lastMessageDt = parseDt(`${lastMessageDate} ${lastMessageTime}:00.0`, 'MM/dd/yyyy HHmm:ss.S', new Date());
        threadSummariesDto.push({
            threadId,
            subject: _get(data, 'subject'),
            jobId: _get(data, 'jobId'),
            jobTitle: _get(data, 'jobTitle'),
            // jobSeekerId: _get(data, 'jobSeekerId'),
            // jobSeekerName: _get(data, 'jobSeekerName'),
            // jobSeekerProfileImageUrl: _get(data, 'jobSeekerProfileImageUrl', ''),
            jobSeekerLastReadDt: jobSeekerLastReadDt, //firebase.firestore.Timestamp.fromDate(jobSeekerLastReadDt),
            jobSeekerNewMessagesCount: _get(data, 'jobSeekerNewMessagesCount', 0),
            employerId: _get(data, 'employerId'),
            companyName: _get(data, 'companyName'),
            employerProfileImageUrl: _get(data, 'employerProfileImageUrl', ''),
            // employerLastReadDt: firebase.firestore.Timestamp.fromDate(employerLastReadDt),
            // employerNewMessagesCount: _get(data, 'employerNewMessagesCount',0),
            lastMessageDt: lastMessageDt, //firebase.firestore.Timestamp.fromDate(lastMessageDt),
        });
    });
    const dto = {
        jobSeekerId: _get(myMessagesJson, 'jobSeekerId'),
        jobSeekerName: _get(myMessagesJson, 'jobSeekerName'),
        // employerId: _get(myMessagesJson, 'employerId'),
        // companyName: _get(myMessagesJson, 'companyName'),
        threadSummaries: threadSummariesDto,
    };
    // dev JS userId ekOVkRuQj1evtfnLsoHVfyeia632
    // vendor JS userId 8WDLtWTAXmWWv1WyvkecQd8vqjm1
    db.collection('myMessages')
        .doc('ekOVkRuQj1evtfnLsoHVfyeia632')
        .set(dto)
        // .add(dto)
        .then((/* docRef */) => {
            setSnackbarMessage('Records added');
        })
        .catch(error => {
            console.log('Transaction failed: ', error);
        });
};

export const addThreadMessage = async ({ messageDto, setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        const threadMessagesRef = db.collection('threadMessages');
        await threadMessagesRef.add(messageDto);
        setSnackbarMessage('Sent');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const saveCountryList = async ({ countryList, setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        const mappedCountryList = _map(countryList, item => item.name);
        const dto = { countryList: mappedCountryList };
        const lovsRef = db.collection('app').doc('lovs');
        await lovsRef.update(dto);
        setSnackbarMessage('Saved');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const saveStateList = async ({ stateList, countryList, setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        _forEach(countryList, async country => {
            const countryName = country.name;
            const countryId = country.id;
            const states = _filter(stateList, item => item.country_id === countryId + '');
            if (states.length > 0) {
                const mappedStateList = _map(states, item => item.name);
                const dto = { stateList: mappedStateList };
                const stateDocRef = db.collection('app').doc('lovs').collection('countries').doc(_toLower(countryName));
                await stateDocRef.set(dto);
            }
        });
        setSnackbarMessage('Saved');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const saveCityList = async ({ cityList, stateList, countryList, setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        _forEach(countryList, async country => {
            const countryName = country.name;
            const countryId = country.id;
            const states = _filter(stateList, item => item.country_id === countryId + '');
            if (states.length > 0) {
                _forEach(states, async state => {
                    const stateName = state.name;
                    const stateId = state.id;
                    const cities = _filter(cityList, item => item.state_id === stateId + '');
                    if (cities.length > 0) {
                        const mappedCityList = _map(cities, item => item.name);
                        const dto = { cityList: mappedCityList };
                        const cityDocRef = db.collection('app').doc('lovs').collection('countries').doc(_toLower(countryName)).collection('states').doc(_toLower(stateName));
                        await cityDocRef.set(dto);
                    }
                });
            }
        });
        setSnackbarMessage('Saved');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const renameStatesCollection = async ({ setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        const statesRef = db.collection('app').doc('lovs').collection('states');
        const querySnapshot = await statesRef.get();
        _forEach(querySnapshot.docs, doc => {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, ' => ', doc.data());
            db.collection('app').doc('lovs').collection('countries').doc(doc.id).set(doc.data());
        });
        setSnackbarMessage('Saved');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const renameCitiesCollection = async ({ setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        const statesRef = db.collection('app').doc('lovs').collection('states');
        const querySnapshot = await statesRef.get();
        _forEach(querySnapshot.docs, async doc => {
            // doc.data() is never undefined for query doc snapshots
            const citiesRef = db.collection('app').doc('lovs').collection('states').doc(doc.id).collection('cities');
            const citiesQuerySnapshot = await citiesRef.get();
            _forEach(citiesQuerySnapshot.docs, cityDoc => {
                // cityDoc.data() is never undefined for query doc snapshots
                db.collection('app').doc('lovs').collection('countries').doc(doc.id).collection('states').doc(cityDoc.id).set(cityDoc.data());
            });
        });
        setSnackbarMessage('Saved');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

const replaceSlash = (str = '') => {
    if (str.indexOf(' / ') >= 0) {
        return _replace(str, ' / ', ' or ');
    } else if (str.indexOf('/') >= 0) {
        return _replace(str, '/', ' or ');
    }
    return str;
};

export const importCountriesStatesCities = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    const merge = true; //false;

    // if (db) return; // disable this function

    try {
        const response = await fetch('/countries_states_cities.json', {
            // const response = await fetch('/united-states-canada-mexico-japan-mini.json', {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        console.log('serverHelper - importCountriesStatesCities: Got response');

        const countriesStatesCitiesData = await response.json();
        console.log('serverHelper - importCountriesStatesCities: Got countriesStatesCitiesData JSON.');

        //------------------------------------------------
        // Import countryList LOV
        //------------------------------------------------
        const countryList = _map(countriesStatesCitiesData, country => ({
            name: replaceSlash(country.name),
            phoneCode: country.phone_code,
            currency: country.currency,
            native: country.native,
            iso2: country.iso2,
            iso3: country.iso3,
        }));
        console.log(`serverHelper - importCountriesStatesCities: Mapped countryList.  Total: ${countryList.length}`);
        const lovsDocRef = db.collection('lovs').doc('countryLov');
        await lovsDocRef.set({ list: countryList });

        //------------------------------------------------
        // Import each country document
        //------------------------------------------------
        _forEach(countriesStatesCitiesData, async (country, countryIdx) => {
            if (countryIdx >= 0 && countryIdx < 50) {
                // if (countryIdx >= 50 && countryIdx < 100) {
                // if (countryIdx >= 100 && countryIdx < 150) {
                // if (countryIdx >= 150 && countryIdx < 200) {
                // if (countryIdx >= 200 && countryIdx < 300) {
                // if (countryIdx >= 0) {
                const countryName = replaceSlash(country.name);
                const countryDto = { name: countryName, phoneCode: country.phone_code, currency: country.currency, native: country.native, iso2: country.iso2, iso3: country.iso3 };

                // if (countryName === 'United States') {
                //------------------------------------------------
                // Import stateList LOV for each country
                //------------------------------------------------
                const states = _get(country, 'states');
                const stateList = _map(states, state => ({
                    name: replaceSlash(state.name),
                    code: state.state_code,
                }));
                console.log(`serverHelper - importCountriesStatesCities: Mapped ${countryName} stateList.  Total: ${stateList.length}`);
                const countryDocRef = db.collection('countries').doc(_toLower(countryName));
                await countryDocRef.set({ stateList, ...countryDto }, { merge });
                // await countryDocRef.set({ iso2: country.iso2, iso3: country.iso3 }, { merge });

                //------------------------------------------------
                // Import each state document
                //------------------------------------------------
                _forEach(states, async (state /*, stateIdx */) => {
                    const stateName = replaceSlash(state.name);
                    const stateCode = state.state_code;

                    //------------------------------------------------
                    // Import cityList LOV for each state
                    //------------------------------------------------
                    const cities = _get(state, 'cities');
                    const cityList = _map(cities, city => ({
                        name: replaceSlash(city.name),
                        location: getGeoPoint(_toNumber(city.latitude), _toNumber(city.longitude)),
                        state: stateName,
                        country: countryName,
                    }));
                    console.log(`serverHelper - importCountriesStatesCities: Mapped ${countryName} / ${stateName} cityList.  Total: ${cityList.length}`);
                    const stateDocRef = db.collection('countries').doc(_toLower(countryName)).collection('states').doc(_toLower(stateName));
                    await stateDocRef.set({ cityList, name: stateName, country: countryName, code: stateCode }, { merge });
                    // await stateDocRef.set({ code: stateCode }, { merge });

                    // //------------------------------------------------
                    // // This is ONLY run for missed state documents
                    // //------------------------------------------------
                    // const stateDocRef = db.collection('app').doc('lovs').collection('countries').doc(_toLower(countryName)).collection('states').doc(_toLower(stateName));
                    // const stateDoc = await stateDocRef.get();
                    // if (cities.length > 0 && !stateDoc.exists) {
                    //     console.log(`serverHelper - importCountriesStatesCities: Missed ${countryName} / ${stateName} document.`);
                    //     await stateDocRef.set({ cityList });
                    // }

                    //------------------------------------------------
                    // If no cities, use state
                    //------------------------------------------------
                    if (cities.length === 0) {
                        const noCityStateDocRef = db.collection('countries').doc(_toLower(countryName)).collection('states').doc(_toLower(stateName));
                        await noCityStateDocRef.set({ cityList: [{ name: stateName }], name: stateName, country: countryName });
                    }
                });

                //------------------------------------------------
                // If no states, use country
                //------------------------------------------------
                if (states.length === 0) {
                    // console.log('============> no states: ', _toLower(countryName));
                    const noStateCountryDocRef = db.collection('countries').doc(_toLower(countryName));
                    await noStateCountryDocRef.set({ stateList: [{ name: countryName }], ...countryDto });
                    const noCityStateDocRef = db.collection('countries').doc(_toLower(countryName)).collection('states').doc(_toLower(countryName));
                    await noCityStateDocRef.set({ cityList: [{ name: countryName }], name: countryName, country: countryName });
                }
            }
        });

        // //------------------------------------------------
        // // Find the countries/states that have no states/cities
        // //------------------------------------------------
        // _forEach(countriesStatesCitiesData, async (country, countryIdx) => {
        //     const countryName = replaceSlash(country.name);
        //     const states = _get(country, 'states', []);
        //     if (states.length === 0) {
        //         console.log(`No states - ${countryName}`);
        //     }
        //     _forEach(states, async (state, stateIdx) => {
        //         const stateName = replaceSlash(state.name);
        //         const cities = _get(state, 'cities');
        //         if (cities.length === 0) {
        //             console.log(`No cities - ${countryName} / ${stateName}`);
        //         }
        //     });
        // });

        // //------------------------------------------------
        // // Fix Hong Kong state and city
        // //------------------------------------------------
        // const hkCountryDocRef = db.collection('app').doc('lovs').collection('countries').doc('hong kong s.a.r.');
        // await hkCountryDocRef.set({ stateList: [{ name: 'Hong Kong' }] });
        // const hkStateDocRef = db.collection('app').doc('lovs').collection('countries').doc('hong kong s.a.r.').collection('states').doc('hong kong');
        // await hkStateDocRef.set({ cityList: [{ name: 'Hong Kong', location: getGeoPoint(22.3193, 114.1694) }] });

        setSnackbarMessage('Saved');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

// const delay = n => {
//     return new Promise(function (resolve) {
//         setTimeout(resolve, n * 1000);
//     });
// };

//--------------------------------------------------------------------------
// ElasticSearch Sync - countries / states / cities
//--------------------------------------------------------------------------
export const pushCountriesStatesCitiesToElasticSearchFromJson = async ({ esToken, setEsToken, setSnackbarMessage }) => {
    // const db = getFirestore();
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);

    // if (db) return; // disable this function

    try {
        const response = await fetch('/countries_states_cities.json', {
            // const response = await fetch('/united-states-canada-mexico-japan.json', {
            // const response = await fetch('/united-states-canada-mexico-japan-mini.json', {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        console.log('serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: Got response');

        const countriesStatesCitiesData = await response.json();
        console.log('serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: Got countriesStatesCitiesData JSON.');

        let countryList = [];
        let stateList = [];
        let cityList = [];

        //------------------------------------------------
        // Get country list
        //------------------------------------------------
        countryList = _map(countriesStatesCitiesData, country => ({
            id: _toLower(country.name),
            name: replaceSlash(country.name),
            phoneCode: country.phone_code,
            currency: country.currency,
            native: country.native,
        }));
        console.log(`serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: Mapped countryList.  Total: ${countryList.length}`);

        //------------------------------------------------
        // Get state list of the country
        //------------------------------------------------
        _forEach(countriesStatesCitiesData, async (country /*, countryIdx */) => {
            const countryName = replaceSlash(country.name);
            const states = _get(country, 'states');
            const list = _map(states, state => ({
                id: `${_toLower(countryName)}__${_toLower(state.name)}`,
                name: replaceSlash(state.name),
                code: state.state_code,
                country: countryName,
            }));
            console.log(`serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: Mapped ${countryName} stateList.  Total: ${list.length}`);
            stateList = _concat(stateList, list);

            // if no states, add a state and a city record using the country name
            if (!states || states.length === 0) {
                console.log(`serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: ${countryName} no states and cities.`);
                stateList = _concat(stateList, [
                    {
                        id: `${_toLower(countryName)}__${_toLower(countryName)}`,
                        name: countryName,
                        country: countryName,
                    },
                ]);
                cityList = _concat(cityList, [
                    {
                        id: `${_toLower(countryName)}__${_toLower(countryName)}__${_toLower(countryName)}`,
                        name: countryName,
                        state: countryName,
                        country: countryName,
                    },
                ]);
            }

            //------------------------------------------------
            // Get city list of the state in the country
            //------------------------------------------------
            _map(states, async (state /*, stateIdx */) => {
                const stateName = replaceSlash(state.name);
                const cities = _get(state, 'cities');
                const list = _map(cities, city => ({
                    id: `${_toLower(countryName)}__${_toLower(stateName)}__${city.name}`,
                    name: replaceSlash(city.name),
                    location: { lat: _toNumber(city.latitude), lon: _toNumber(city.longitude) },
                    state: stateName,
                    country: countryName,
                }));
                cityList = _concat(cityList, list);
                console.log(`serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: Mapped ${countryName} / ${stateName} cityList.  Total: ${list.length}`);

                // if no cities, add a city record using the state name
                if (!cities || cities.length === 0) {
                    console.log(`serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: ${countryName} / ${stateName} / no cities.`);
                    cityList = _concat(cityList, [
                        {
                            id: `${_toLower(countryName)}__${_toLower(stateName)}__${_toLower(stateName)}`,
                            name: stateName,
                            state: stateName,
                            country: countryName,
                        },
                    ]);
                }
            });
        });

        // Call ElasticSearch API to sync country data
        if (_size(countryList) > 0) {
            console.log(`serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: Pushing COUNTRY...  Total: ${countryList.length}`);
            await callElasticSearch({ url: ELASTICSEARCH_SYNC_API_URL, type: 'COUNTRY', values: countryList, callType: 'SYNC' });
            // console.log('>>>>>>>>>> countries', JSON.stringify(countryList));
        }

        // Call ElasticSearch API to sync state data
        if (_size(stateList) > 0) {
            console.log(`serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: Pushing STATE...  Total: ${stateList.length}`);
            // console.log('>>>>>>>>>> states', JSON.stringify(stateList));
            await callElasticSearch({ url: ELASTICSEARCH_SYNC_API_URL, type: 'STATE', values: stateList, callType: 'SYNC' });
        }

        // Push 50,000 cities at a time
        cityList = cityList.slice(0, 50000);
        // cityList = cityList.slice(50000, 100000);
        // cityList = cityList.slice(100000, 150000);
        // cityList = cityList.slice(150000);

        // Call ElasticSearch API to sync city data
        if (_size(cityList) > 0) {
            console.log(`serverHelper - pushCountriesStatesCitiesToElasticSearchFromJson: Pushing CITY...  Total: ${cityList.length}`);
            await callElasticSearch({ url: ELASTICSEARCH_SYNC_API_URL, type: 'CITY', values: cityList, callType: 'SYNC' });
            // console.log('>>>>>>>>>> cities', JSON.stringify(cityList));
        }

        setSnackbarMessage('Pushed to ElasticSearch');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const clearJobRelatedData = async ({ setSnackbarMessage }) => {
    const db = getFirestore();

    //=====================================================================
    // Collections
    //=====================================================================
    const batch = db.batch();

    // // users
    // const usersQuery = db.collection('users').where('type', '==', 'JS');
    // const usersQuerySnapshot = await usersQuery.get();
    // usersQuerySnapshot.forEach(doc => {
    //     batch.update(doc.ref, { appliedJobs: [], bookmarkedJobs: [] });
    // });

    // // employers
    // const empsQuery = db.collection('employers');
    // const empsQuerySnapshot = await empsQuery.get();
    // empsQuerySnapshot.forEach(doc => {
    //     batch.update(doc.ref, { jsEngagedList: [] });
    // });

    // // dashboards
    // const dashboardsQuery = db.collection('dashboards');
    // const dashboardsQuerySnapshot = await dashboardsQuery.get();
    // dashboardsQuerySnapshot.forEach(doc => {
    //     batch.update(doc.ref, {
    //         actionNeededInterviewCount: getFirestoreDeleteField(),
    //         actionNeededPendingInterviews: getFirestoreDeleteField(),
    //         actionNeededRescheduledInterviews: getFirestoreDeleteField(),
    //         pendingInterviewCount: getFirestoreDeleteField(),
    //         unreadConfirmedInterviews: getFirestoreDeleteField(),
    //         unreadDeclinedInterviews: getFirestoreDeleteField(),
    //         unreadMsgsCounts: getFirestoreDeleteField(),
    //         unreadMessagesCount: getFirestoreDeleteField(), // not in data model
    //         unreadMessagesCounts: getFirestoreDeleteField(), // not in data model
    //         unreadNewApplicants: getFirestoreDeleteField(),
    //     });
    // });

    // // profilesEmp
    // const profilesEmpQuery = db.collection('profilesEmp');
    // const profilesEmpQuerySnapshot = await profilesEmpQuery.get();
    // profilesEmpQuerySnapshot.forEach(doc => {
    //     batch.update(doc.ref, { activeJobsCount: 0 });
    // });

    batch.commit();

    //=====================================================================
    // Collections
    //=====================================================================
    // let docIds = [];

    // // appliedJobs
    // const appliedJobsQuery = db.collection('appliedJobs');
    // const appliedJobsQuerySnapshot = await appliedJobsQuery.get();
    // appliedJobsQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // // brandJobs
    // const brandJobsQuery = db.collection('brandJobs');
    // const brandJobsQuerySnapshot = await brandJobsQuery.get();
    // brandJobsQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // // interviewNotes
    // const interviewNotesQuery = db.collection('interviewNotes');
    // const interviewNotesQuerySnapshot = await interviewNotesQuery.get();
    // interviewNotesQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // // interviewNotesEmp
    // const interviewNotesEmpQuery = db.collection('interviewNotesEmp');
    // const interviewNotesEmpQuerySnapshot = await interviewNotesEmpQuery.get();
    // interviewNotesEmpQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // // interviews
    // const interviewsQuery = db.collection('interviews');
    // const interviewsQuerySnapshot = await interviewsQuery.get();
    // interviewsQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // // jobs
    // const jobsQuery = db.collection('jobs');
    // const jobsQuerySnapshot = await jobsQuery.get();
    // jobsQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // // myJobsEmp.engagements
    // // myJobsEmp
    // docIds = [];
    // const myJobsEmpQuery = db.collection('myJobsEmp');
    // const myJobsEmpQuerySnapshot = await myJobsEmpQuery.get();
    // myJobsEmpQuerySnapshot.forEach(async doc => {
    //     docIds.push(doc.id);
    // });
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         const engagementsQuery = db.collection(`myJobsEmp/${docId}/engagements`);
    //         const engagementsQuerySnapshot = await engagementsQuery.get();
    //         engagementsQuerySnapshot.forEach(doc => {
    //             doc.ref.delete();
    //         });
    //     }),
    // );
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         db.doc(`myJobsEmp/${docId}`).delete();
    //     }),
    // );

    // // myJobs.appliedJobs
    // // myJobs.jsSavedJobs
    // // myJobs
    // docIds = [];
    // const myJobsQuery = db.collection('myJobs');
    // const myJobsQuerySnapshot = await myJobsQuery.get();
    // myJobsQuerySnapshot.forEach(async doc => {
    //     docIds.push(doc.id);
    // });
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         const appliedJobsQuery = db.collection(`myJobs/${docId}/appliedJobs`);
    //         const appliedJobsQuerySnapshot = await appliedJobsQuery.get();
    //         appliedJobsQuerySnapshot.forEach(doc => {
    //             doc.ref.delete();
    //         });
    //     }),
    // );
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         const jsSavedJobsQuery = db.collection(`myJobs/${docId}/jsSavedJobs`);
    //         const jsSavedJobsQuerySnapshot = await jsSavedJobsQuery.get();
    //         jsSavedJobsQuerySnapshot.forEach(doc => {
    //             doc.ref.delete();
    //         });
    //     }),
    // );
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         db.doc(`myJobs/${docId}`).delete();
    //     }),
    // );

    // // myMessages.threadSummaries
    // // myMessages
    // docIds = [];
    // const myMessagesQuery = db.collection('myMessages');
    // const myMessagesQuerySnapshot = await myMessagesQuery.get();
    // myMessagesQuerySnapshot.forEach(async doc => {
    //     docIds.push(doc.id);
    // });
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         const threadSummariesQuery = db.collection(`myMessages/${docId}/threadSummaries`);
    //         const threadSummariesQuerySnapshot = await threadSummariesQuery.get();
    //         threadSummariesQuerySnapshot.forEach(doc => {
    //             doc.ref.delete();
    //         });
    //     }),
    // );
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         db.doc(`myMessages/${docId}`).delete();
    //     }),
    // );

    // // threadMessages
    // const threadMessagesQuery = db.collection('threadMessages');
    // const threadMessagesQuerySnapshot = await threadMessagesQuery.get();
    // threadMessagesQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // // threads.messageSets
    // // threads
    // docIds = [];
    // const threadsQuery = db.collection('threads');
    // const threadsQuerySnapshot = await threadsQuery.get();
    // threadsQuerySnapshot.forEach(async doc => {
    //     docIds.push(doc.id);
    // });
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         const messageSetsQuery = db.collection(`threads/${docId}/messageSets`);
    //         const messageSetsQuerySnapshot = await messageSetsQuery.get();
    //         messageSetsQuerySnapshot.forEach(doc => {
    //             doc.ref.delete();
    //         });
    //     }),
    // );
    // await Promise.all(
    //     _map(docIds, async docId => {
    //         db.doc(`threads/${docId}`).delete();
    //     }),
    // );

    // // sharedJobs
    // const sharedJobsQuery = db.collection('sharedJobs');
    // const sharedJobsQuerySnapshot = await sharedJobsQuery.get();
    // sharedJobsQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // // savedJobSeekers
    // const savedJobSeekersQuery = db.collection('savedJobSeekers');
    // const savedJobSeekersQuerySnapshot = await savedJobSeekersQuery.get();
    // savedJobSeekersQuerySnapshot.forEach(doc => {
    //     doc.ref.delete();
    // });

    // setSnackbarMessage('Saved');
    setSnackbarMessage('Save Disabled');

    // // do this to get around linter warning
    // if (db || getFirestoreDeleteField || docIds) {
    // }
};

export const addCreatableLovItems = async ({ lovCollectionName, lovListJsonStr, setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        const lovList = _get(JSON.parse(lovListJsonStr), 'list');
        // let dto = {};

        const collectionRef = db.collection(lovCollectionName);
        await Promise.all(
            _map(lovList, async item => {
                const doc = await collectionRef.add({ name: item });
                return doc;
            }),
        );

        setSnackbarMessage('Saved');
        // setSnackbarMessage('Save Disabled');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const addDynamicDocs = async ({ collectionPath, docsJsonStr, setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        const docDataList = JSON.parse(docsJsonStr);
        // let dto = {};

        const collectionRef = db.collection(collectionPath);
        Promise.all(
            _map(docDataList, async docData => {
                const doc = await collectionRef.add(docData);
                return doc;
            }),
        );

        setSnackbarMessage('Saved');
        // setSnackbarMessage('Save Disabled');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const addDynamicData = async ({ docPath, fieldName, dataJsonStr, setSnackbarMessage }) => {
    const db = getFirestore();

    try {
        // const [collection, docId, fieldName] = _split(fieldPath, '.');
        const fieldData = JSON.parse(dataJsonStr);
        let dto = {};
        //---------------------
        // db.collection('app').doc('lovs').collection('countries').doc('canada').collection('states').doc('british columbia').set(data);
        //---------------------
        // const list = _map(data.cityList, item => item.name);
        // db.collection('app').doc('lovs').collection('countries').doc('canada').collection('states').doc('british columbia').set({ cityList: list });
        //---------------------
        // _forEach(data.states, state => {
        //     const list = _map(
        //         _filter(data.cities, city => city.state_id === state.id),
        //         item => item.name,
        //     );
        //     db.collection('app').doc('lovs').collection('countries').doc('united states').collection('states').doc(_toLower(state.name)).set({ cityList: list });
        // });
        //---------------------
        // const jobSeekerLastReadDate = _get(data, 'jobSeekerLastReadDate', '08/08/2020');
        // const jobSeekerLastReadTime = _get(data, 'jobSeekerLastReadTime', '13:00');
        // const jobSeekerLastReadDt = parseDt(`${jobSeekerLastReadDate} ${jobSeekerLastReadTime}:00.0`, 'MM/dd/yyyy HHmm:ss.S', new Date());
        // _set(data, 'jobSeekerLastReadDt', firebase.firestore.Timestamp.fromDate(jobSeekerLastReadDt));
        // const lastMessageDate = _get(data, 'lastMessageDate', '08/08/2020');
        // const lastMessageTime = _get(data, 'lastMessageTime', '13:00');
        // const lastMessageDt = parseDt(`${lastMessageDate} ${lastMessageTime}:00.0`, 'MM/dd/yyyy HHmm:ss.S', new Date());
        // _set(data, 'lastMessageDt', firebase.firestore.Timestamp.fromDate(lastMessageDt));
        // // // DEV userId Ew0BPLvNjaZnXwQq5xVnf5QRQIM2
        // // // TEST userId 5uX46DTNCqe9YGtNMSxv2vItm8A2
        // // const myMessagesDocRef = db.collection('myMessages').doc('5uX46DTNCqe9YGtNMSxv2vItm8A2');
        // // myMessagesDocRef.update({
        // //     threadSummaries: firebase.firestore.FieldValue.arrayUnion(data),
        // // });
        //---------------------
        const docRef = db.doc(docPath);
        const doc = await docRef.get();
        if (doc.exists) {
            dto = { ...doc.data(), [fieldName]: fieldData };
        } else {
            dto = { [fieldName]: fieldData };
        }
        docRef.set(dto);
        //---------------------

        setSnackbarMessage('Saved');
        // setSnackbarMessage('Save Disabled');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const generatePromoCode = async ({ promoCodeType /*, setSnackbarMessage */ }) => {
    const db = getFirestore();
    const now = new Date();

    let newPromoCodes = voucherCodeGenerator.generate({
        length: 7,
        count: 1,
        charset: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    });

    const newPromoCode = newPromoCodes[0];
    // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>', { newPromoCode });

    const promoCodeDocRef = db.collection('promoCodes').doc(newPromoCode);
    const promoCodeDoc = await promoCodeDocRef.get();

    if (promoCodeDoc.exists) {
        return `Promo Code '${newPromoCode}' already exists.  Try again.`;
    } else {
        promoCodeDocRef.set({
            createDt: now,
            type: promoCodeType,
        });

        return newPromoCode;
    }
};

export const beginNewBillCycle = async ({ employerId, setSnackbarMessage }) => {
    const db = getFirestore();
    // const batch = db.batch();
    try {
        //----------------------------------------------------------------------
        // get employer data
        //----------------------------------------------------------------------
        const empDocRef = db.collection('employers').doc(employerId);
        const empDoc = await empDocRef.get();
        if (empDoc.exists) {
            let empData = empDoc.data();
            empData = convertFirebaseTimestampsToDate(empData, ['subscriptionDt', 'billCycleStartDt', 'downgradeSubscriptionDt', 'unsubscribeDt']);

            const { subscriptionDt, tier, members = [], tierNew, membersNew = [], billCycleStartDt, downgradeSubscriptionDt, unsubscribeDt, subscriptionHistory = [] } = empData;

            // set new billing cycle dates
            const newBillCycleStartDt = new Date();
            const newBillCycleEndDt = addMonths(newBillCycleStartDt, 1);

            let dto = {
                billMonthly: true,
                billCycleStartDt: newBillCycleStartDt,
                billCycleEndDt: newBillCycleEndDt,
            };

            if (!_isNil(downgradeSubscriptionDt) && isAfter(downgradeSubscriptionDt, billCycleStartDt)) {
                // user is downgrading plan
                dto = {
                    ...dto,
                    subscriptionDt: newBillCycleStartDt,
                    tier: tierNew,
                    members: membersNew,
                    tierNew: null,
                    membersNew: null,
                    downgradeSubscriptionDt: null,
                    unsubscribeDt: null,
                    additionalSeats: 0,
                    // new field
                    subscriptionHistory: [
                        ...subscriptionHistory,
                        {
                            subscriptionDt,
                            tier,
                            members,
                            downgradeSubscriptionDt,
                        },
                    ],
                };

                // each old member
                _forEach(members, async member => {
                    const { userId } = member;
                    const userDocRef = db.collection('users').doc(userId);
                    const userDoc = await userDocRef.get();
                    const userData = userDoc.data(); //assume user doc exists
                    let { employers: userEmployers = [] } = userData;
                    const userInNewMember = _find(membersNew, { userId });
                    if (!userInNewMember) {
                        _remove(userEmployers, { employerId });
                    } else {
                        userEmployers = _union(userEmployers, { employerId });
                    }
                    console.log('>>>>>>>>>>>>>>>>>>>> ', userEmployers);
                    userDocRef.update({ active: userEmployers.length !== 0, employers: userEmployers });
                });
            } else if (!_isNil(unsubscribeDt)) {
                // employer has cancelled subscription
                dto = {
                    ...dto,
                    status: 'I', // new field (A / I / P - active, inactive, pending)
                };

                // each member
                _forEach(members, async member => {
                    const { userId } = member;
                    const userDocRef = db.collection('users').doc(userId);
                    const userDoc = await userDocRef.get();
                    const userData = userDoc.data(); //assume user doc exists
                    let { employers: userEmployers = [] } = userData;
                    _remove(userEmployers, o => o.employerId === employerId);
                    console.log('>>>>>>>>>>>>>>>>>>>> ', userEmployers);
                    userDocRef.update({ active: userEmployers.length !== 0, employers: userEmployers });
                });
            }

            empDocRef.update(dto);
            setSnackbarMessage('Employer record updated');
        }
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const memberAcceptEmployerInvite = async ({ employerId, memberAcceptInviteJsonStr, setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        let memberData = JSON.parse(memberAcceptInviteJsonStr);
        const { email: memberEmail, userId: memberUserId } = memberData;

        const empDocRef = db.collection('employers').doc(employerId);
        const empDoc = await empDocRef.get();
        if (empDoc.exists) {
            let empData = empDoc.data();
            let { members } = empData;

            _remove(members, member => member.userId === memberUserId);
            members.push(memberData);

            empDocRef.update({ invited: getArrayRemove(memberEmail), members });
        }

        const userDocRef = db.collection('users').doc(memberUserId);
        userDocRef.update({ employers: getArrayUnion({ employerId }) });

        setSnackbarMessage('Invite accepted');
    } catch (error) {
        console.log('Error fetching user data:', error);
    }
};

export const reactivateEmployer = async ({ employerId, ownerUserId, setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        const userDocRef = db.collection('users').doc(ownerUserId);
        userDocRef.update({ employers: getArrayUnion({ employerId }) });

        //TODO Clean up old data in the employer record according to new tier

        setSnackbarMessage('Invite accepted');
    } catch (error) {
        console.log('Error fetching user data:', error);
    }
};

export const setUpEmployer = async ({ userId, employerJson, setSnackbarMessage }) => {
    const db = getFirestore();
    const now = new Date();
    const oneMonthLater = addMonths(now, 1);
    try {
        //----------------------------------------------------------------------
        // get user data
        //----------------------------------------------------------------------
        const userDocRef = db.collection('users').doc(userId);
        const userDoc = await userDocRef.get();
        if (userDoc.exists) {
            const userData = userDoc.data();
            const { email = 'default@email.com' } = userData;

            //----------------------------------------------------------------------
            // insert employer record
            //----------------------------------------------------------------------
            let dto = JSON.parse(employerJson);
            const memberDto = { ..._get(dto, 'members[0]', {}), email, userId };
            _set(dto, 'members[0]', memberDto);

            const employerDocRef = await db.collection('employers').add({ billCycleStartDt: now, billCycleEndDt: oneMonthLater, billMonthly: true, ...dto, createDt: now });
            const employerId = employerDocRef.id;
            console.log('employerDoc id ', employerId);
            setSnackbarMessage('Employer record added');

            //----------------------------------------------------------------------
            // add to employers array in user record
            //----------------------------------------------------------------------
            const { employers = [] } = userData;
            const userDto = { employers: [...employers, { employerId }], type: USER_TYPE_EMP };
            await db.collection('users').doc(userId).update(userDto);
            setSnackbarMessage('User record updated');
        } else {
            console.log(`User document (${userId}) not found!`);
        }
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const changeCurrentUserPassword = async ({ newPassword, setSnackbarMessage }) => {
    // const db = getFirestore();
    try {
        const user = getFirebaseAuth().currentUser;
        await user.updatePassword(newPassword);
        setSnackbarMessage('Password changed');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const changeCurrentUserEmail = async ({ newEmail, setSnackbarMessage }) => {
    // const db = getFirestore();
    try {
        const user = getFirebaseAuth().currentUser;
        await user.updateEmail(newEmail);
        setSnackbarMessage('Email changed');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const sendResetPasswordEmail = async ({ auth, email, setSnackbarMessage }) => {
    // const db = getFirestore();
    try {
        auth.sendPasswordResetEmail(email);
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

let totalCloudStorageItemSize = 0;
let cloudStorageItemCount = 0;
let totalOversizedCloudStorageItemSize = 0;
let oversizedCloudStorageItemCount = 0;

const iterateCloudStorageObject = async (path, showOversizedOnly) => {
    const storageRef = getCloudStorage().ref();
    var rootRef = storageRef.child(path);
    const res = await rootRef.listAll();
    await Promise.all(
        res.items.map(async itemRef => {
            const metadata = await itemRef.getMetadata();
            const itemSize = metadata.size;
            const { size, unit } = convertFileSize(itemSize);
            if (showOversizedOnly) {
                if (itemSize > 400000) {
                    console.log(`${metadata.fullPath} / ${size} ${unit}`);
                    totalOversizedCloudStorageItemSize += itemSize;
                    oversizedCloudStorageItemCount++;
                }
            } else {
                console.log(`${metadata.fullPath} / ${size} ${unit}`);
            }
            totalCloudStorageItemSize += itemSize;
            cloudStorageItemCount++;
        }),
    );
    await Promise.all(
        res.prefixes.map(async folderRef => {
            await iterateCloudStorageObject(folderRef.fullPath, showOversizedOnly);
        }),
    );
};

export const showCloudStorageObjectList = async ({ showOversizedOnly } = {}) => {
    // var rootRef = storageRef.child('users/0ZxFYNYmzAVTFdXNsF2k7vmwYb93/profilePicture');
    totalCloudStorageItemSize = 0;
    cloudStorageItemCount = 0;
    oversizedCloudStorageItemCount = 0;
    await iterateCloudStorageObject('', showOversizedOnly);
    const { size, unit } = convertFileSize(totalCloudStorageItemSize);
    console.log(`-=-=-=-=-=------> Total Cloud Storage Usage (${cloudStorageItemCount} objects): ${size} ${unit}`);

    const { size: size2, unit: unit2 } = convertFileSize(totalOversizedCloudStorageItemSize);
    console.log(`-=-=-=-=-=------> Total Oversized Cloud Storage Usage (${oversizedCloudStorageItemCount} objects): ${size2} ${unit2}`);
};

export const saveStripeTestClockId = async ({ employerId, stripeTestClockId, setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        const empDocRef = db.collection('employers').doc(employerId);
        const empDoc = await empDocRef.get();
        if (empDoc.exists) {
            empDocRef.update({ stripeTestClockId });
        } else {
            console.log('Cannot find employer');
        }

        setSnackbarMessage('Saved Test Clock ID');
    } catch (error) {
        console.log('Error saving test clock ID:', error);
    }
};

//-----------------------------------------------------------------------------
// Map ElasticSearch Type to the corresponding 'sync' service
//-----------------------------------------------------------------------------
export const collectionEsSyncServices = {
    //--------------------------------------------------------------------------
    // collections with unique doc.id
    //--------------------------------------------------------------------------
    OCCUPATION: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushCollectionToElasticSearch({ collectionName: 'occupations', esTypeName: 'OCCUPATION', esToken, setEsToken, setSnackbarMessage });
    },
    INDUSTRY: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushCollectionToElasticSearch({ collectionName: 'industries', esTypeName: 'INDUSTRY', esToken, setEsToken, setSnackbarMessage });
    },
    OTHER_EDUCATION: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushCollectionToElasticSearch({ collectionName: 'otherEducations', esTypeName: 'OTHER_EDUCATION', esToken, setEsToken, setSnackbarMessage });
    },
    SKILL_SET: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushCollectionToElasticSearch({ collectionName: 'skillSets', esTypeName: 'SKILL_SET', esToken, setEsToken, setSnackbarMessage });
    },
    JOB: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushCollectionToElasticSearch({ collectionName: 'jobs', esTypeName: 'JOB', esToken, setEsToken, setSnackbarMessage });
    },
    EMP_PROFILE: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushCollectionToElasticSearch({ collectionName: 'profilesEmp', esTypeName: 'EMP_PROFILE', esToken, setEsToken, setSnackbarMessage });
    },
    JS_PROFILE: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushCollectionToElasticSearch({ collectionName: 'profiles', esTypeName: 'JS_PROFILE', esToken, setEsToken, setSnackbarMessage });
    },
    MESSAGE: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushCollectionToElasticSearch({ collectionName: 'threadMessages', esTypeName: 'MESSAGE', esToken, setEsToken, setSnackbarMessage });
    },
    //--------------------------------------------------------------------------
    // sub-collections with non-unique doc.id
    //--------------------------------------------------------------------------
    EMP_JOB: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushEmpJobsToElasticSearch({ esToken, setEsToken, setSnackbarMessage });
    },
    THREAD_SUMMARIES: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushThreadSummariesToElasticSearch({ esToken, setEsToken, setSnackbarMessage });
    },
    JS_APPLIED_JOB: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushJsAppliedJobsToElasticSearch({ esToken, setEsToken, setSnackbarMessage });
    },
    JS_SAVED_JOB: ({ esToken, setEsToken, setSnackbarMessage } = {}) => {
        pushJsSavedJobsToElasticSearch({ esToken, setEsToken, setSnackbarMessage });
    },
};

//--------------------------------------------------------------------------
// ElasticSearch Sync - Primary collections (E.g. industries, jobs, threadMessages, etc.)
//--------------------------------------------------------------------------
export const pushCollectionToElasticSearch = async ({ collectionName, esTypeName, esToken, setEsToken, setSnackbarMessage }) => {
    const db = getFirestore();
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);

    try {
        let list = [];
        const collectionRef = db.collection(collectionName);
        const collectionSnapshot = await collectionRef.get();
        collectionSnapshot.forEach(doc => {
            const data = doc.data();
            let mappedJson = null;
            // some collections require special mappings (with timestamp fields, geo-point fields etc.)
            switch (collectionName) {
                case 'jobs': {
                    mappedJson = mapJobsDataToElasticSearchJson(data, doc.id);
                    break;
                }
                case 'profilesEmp': {
                    mappedJson = mapProfilesEmpDataToElasticSearchJson(data, doc.id);
                    break;
                }
                case 'profiles': {
                    mappedJson = mapProfilesDataToElasticSearchJson(data, doc.id);
                    break;
                }
                case 'threadMessages': {
                    mappedJson = mapThreadMessagesDataToElasticSearchJson(data, doc.id);
                    break;
                }
                default:
                    // all other collections that don't need special mappings
                    mappedJson = { ...data, id: doc.id };
            }
            list.push(mappedJson);
        });

        if (_size(list) > 0) {
            await callElasticSearch({ url: ELASTICSEARCH_SYNC_API_URL, type: esTypeName, values: list, callType: 'SYNC' });
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', { list });
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', JSON.stringify(list));
        }

        setSnackbarMessage('Pushed to ElasticSearch');
        // setSnackbarMessage('Save Disabled');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

//--------------------------------------------------------------------------
// ElasticSearch Sync - Sub-collection empJobs
//--------------------------------------------------------------------------
export const pushEmpJobsToElasticSearch = async ({ esToken, setEsToken, setSnackbarMessage }) => {
    const db = getFirestore();
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);

    try {
        let idList = [];
        let list = [];
        let missingFieldDocList = [];
        const myJobsEmpQuery = db.collection('myJobsEmp');
        const myJobsEmpSnapshot = await myJobsEmpQuery.get();
        myJobsEmpSnapshot.forEach(doc => {
            idList.push(doc.id);
        });

        await Promise.all(
            _map(idList, async id => {
                const empJobsQuery = db.collection(`myJobsEmp/${id}/empJobs`);
                const collectionSnapshot = await empJobsQuery.get();
                collectionSnapshot.forEach(doc => {
                    const data = doc.data();
                    const { esId: esIdFromDoc, parentId: parentIdFromDoc } = data;
                    const esId = esIdFromDoc || nanoid();
                    const parentId = parentIdFromDoc || id;

                    const mappedJson = mapEmpJobsDataToElasticSearchJson(data, doc.id, esId, parentId);
                    list.push(mappedJson);

                    if (!esIdFromDoc || !parentIdFromDoc) {
                        missingFieldDocList.push({ parentId: id, docId: doc.id, esId });
                    }
                });
            }),
        );

        // Fix missing esId/parentId on the fly
        _forEach(missingFieldDocList, data => {
            const { parentId, docId, esId } = data;
            const empJobDocRef = db.doc(`myJobsEmp/${parentId}/empJobs/${docId}`);
            empJobDocRef.update({ esId, parentId });
        });

        // Call ElasticSearch API to sync data
        if (_size(list) > 0) {
            // await getElasticSearchSyncPostFetch({ url: ELASTICSEARCH_SYNC_API_URL, type: 'EMP_JOB', values: list, token: checkedEsToken.token });
            await callElasticSearch({ url: ELASTICSEARCH_SYNC_API_URL, type: 'EMP_JOB', values: list, callType: 'SYNC' });
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', { list });
        }

        setSnackbarMessage('Pushed to ElasticSearch');
        // setSnackbarMessage('Save Disabled');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

//--------------------------------------------------------------------------
// ElasticSearch Sync - Sub-collection threadSummaries
//--------------------------------------------------------------------------
export const pushThreadSummariesToElasticSearch = async ({ esToken, setEsToken, setSnackbarMessage }) => {
    const db = getFirestore();
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);

    try {
        let idList = [];
        let list = [];
        let missingFieldDocList = [];
        const myMessagesQuery = db.collection('myMessages');
        const myMessagesSnapshot = await myMessagesQuery.get();
        myMessagesSnapshot.forEach(doc => {
            idList.push(doc.id);
        });

        await Promise.all(
            _map(idList, async id => {
                const threadSummariesQuery = db.collection(`myMessages/${id}/threadSummaries`);
                const collectionSnapshot = await threadSummariesQuery.get();
                collectionSnapshot.forEach(doc => {
                    const data = doc.data();
                    const { esId: esIdFromDoc, parentId: parentIdFromDoc } = data;
                    const esId = esIdFromDoc || nanoid();
                    const parentId = parentIdFromDoc || id;

                    const mappedJson = mapThreadSummariesDataToElasticSearchJson(data, esId, parentId);
                    list.push(mappedJson);

                    if (!esIdFromDoc || !parentIdFromDoc) {
                        missingFieldDocList.push({ parentId: id, docId: doc.id, esId });
                    }
                });
            }),
        );

        // Fix missing esId/parentId on the fly
        _forEach(missingFieldDocList, data => {
            const { parentId, docId, esId } = data;
            const threadSummaryDocRef = db.doc(`myMessages/${parentId}/threadSummaries/${docId}`);
            threadSummaryDocRef.update({ esId, parentId });
        });

        // Call ElasticSearch API to sync data
        if (_size(list) > 0) {
            await callElasticSearch({ url: ELASTICSEARCH_SYNC_API_URL, type: 'THREAD_SUMMARY', values: list, callType: 'SYNC' });
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', { list });
        }

        setSnackbarMessage('Pushed to ElasticSearch');
        // setSnackbarMessage('Save Disabled');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

//--------------------------------------------------------------------------
// ElasticSearch Sync - Sub-collection jsAppliedJobs (appliedJobs)
//--------------------------------------------------------------------------
export const pushJsAppliedJobsToElasticSearch = async ({ esToken, setEsToken, setSnackbarMessage }) => {
    const db = getFirestore();
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);

    try {
        let idList = [];
        let list = [];
        let missingFieldDocList = [];
        const myJobsQuery = db.collection('myJobs');
        const myJobsSnapshot = await myJobsQuery.get();
        myJobsSnapshot.forEach(doc => {
            idList.push(doc.id);
        });

        await Promise.all(
            _map(idList, async id => {
                const appliedJobsQuery = db.collection(`myJobs/${id}/appliedJobs`);
                const collectionSnapshot = await appliedJobsQuery.get();
                collectionSnapshot.forEach(doc => {
                    const data = doc.data();
                    const { esId: esIdFromDoc, parentId: parentIdFromDoc } = data;
                    const esId = esIdFromDoc || nanoid();
                    const parentId = parentIdFromDoc || id;

                    const mappedJson = mapJsAppliedJobsDataToElasticSearchJson(data, esId, parentId);
                    list.push(mappedJson);

                    if (!esIdFromDoc || !parentIdFromDoc) {
                        missingFieldDocList.push({ parentId: id, docId: doc.id, esId });
                    }
                });
            }),
        );

        // Fix missing esId/parentId on the fly
        _forEach(missingFieldDocList, data => {
            const { parentId, docId, esId } = data;
            const appliedJobRef = db.doc(`myJobs/${parentId}/appliedJobs/${docId}`);
            appliedJobRef.update({ esId, parentId });
        });

        // Call ElasticSearch API to sync data
        if (_size(list) > 0) {
            await callElasticSearch({ url: ELASTICSEARCH_SYNC_API_URL, type: 'JS_APPLIED_JOB', values: list, callType: 'SYNC' });
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', { list });
        }

        setSnackbarMessage('Pushed to ElasticSearch');
        // setSnackbarMessage('Save Disabled');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

//--------------------------------------------------------------------------
// ElasticSearch Sync - Sub-collection jsSavedJobs
//--------------------------------------------------------------------------
export const pushJsSavedJobsToElasticSearch = async ({ esToken, setEsToken, setSnackbarMessage }) => {
    const db = getFirestore();
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);

    try {
        let idList = [];
        let list = [];
        let missingFieldDocList = [];
        const myJobsQuery = db.collection('myJobs');
        const myJobsSnapshot = await myJobsQuery.get();
        myJobsSnapshot.forEach(doc => {
            idList.push(doc.id);
        });

        await Promise.all(
            _map(idList, async id => {
                const jsSavedJobsQuery = db.collection(`myJobs/${id}/jsSavedJobs`);
                const collectionSnapshot = await jsSavedJobsQuery.get();
                collectionSnapshot.forEach(doc => {
                    const data = doc.data();
                    const { esId: esIdFromDoc, parentId: parentIdFromDoc } = data;
                    const esId = esIdFromDoc || nanoid();
                    const parentId = parentIdFromDoc || id;

                    const mappedJson = mapJsSavedJobsDataToElasticSearchJson(data, esId, parentId);
                    list.push(mappedJson);

                    if (!esIdFromDoc || !parentIdFromDoc) {
                        missingFieldDocList.push({ parentId: id, docId: doc.id, esId });
                    }
                });
            }),
        );

        // Fix missing esId/parentId on the fly
        _forEach(missingFieldDocList, data => {
            const { parentId, docId, esId } = data;
            const appliedJobRef = db.doc(`myJobs/${parentId}/jsSavedJobs/${docId}`);
            appliedJobRef.update({ esId, parentId });
        });

        // Call ElasticSearch API to sync data
        if (_size(list) > 0) {
            await callElasticSearch({ url: ELASTICSEARCH_SYNC_API_URL, type: 'JS_SAVED_JOB', values: list, callType: 'SYNC' });
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', { list });
        }

        setSnackbarMessage('Pushed to ElasticSearch');
        // setSnackbarMessage('Save Disabled');
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

export const populateEngagementFields = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all engagements
        const list = [];
        const engagementsQuery = db.collectionGroup('engagements');

        const collectionSnapshot = await engagementsQuery.get();
        collectionSnapshot.forEach(doc => {
            list.push({ ...doc.data(), uid: doc.id, ref: doc.ref });
        });

        // // populate engagements jobTitle
        // await Promise.all(
        //     _map(list, async engagement => {
        //         // const uid = engagement.uid
        //         const ref = engagement.ref;
        //         const jobId = engagement.jobId;
        //         if (!engagement.jobTitle) {
        //             const doc = await db.doc(`jobs/${jobId}`).get();
        //             if (doc.exists) {
        //                 const data = doc.data();
        //                 await ref.update({ jobTitle: data.jobTitle });
        //             }
        //         }
        //     }),
        // );

        // populate engagements jsName
        await Promise.all(
            _map(list, async engagement => {
                // const uid = engagement.uid
                const ref = engagement.ref;
                const jsId = engagement.jsId;
                if (!engagement.jsName) {
                    const doc = await db.doc(`users/${jsId}`).get();
                    if (doc.exists) {
                        const data = doc.data();
                        await ref.update({ jsName: getFullNameByUser(data) });
                    }
                }
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const fixJsEngageCounts = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all employers
        const list = [];
        const empQuery = db.collectionGroup('employers');

        const collectionSnapshot = await empQuery.get();
        collectionSnapshot.forEach(doc => {
            list.push(convertFirebaseTimestampsToDate({ ...doc.data(), uid: doc.id, ref: doc.ref }, ['billCycleStartDt']));
        });

        await Promise.all(
            _map(list, async emp => {
                const uid = emp.uid;
                const ref = emp.ref;
                const tier = emp.tier;
                const billCycleStartDt = emp.billCycleStartDt;
                // count engagements if employer does not have test clock and billCycleStartDt is available
                if (!emp.stripeTestClockId && !_isNil(billCycleStartDt)) {
                    let count = 0;
                    const engagementsSnapshot = await db.collection(`myJobsEmp/${uid}/engagements`).where('engageDt', '>', billCycleStartDt).get();
                    engagementsSnapshot.forEach(async doc => {
                        count++;
                    });
                    // console.log(`employerId: ${uid} - count: ${count}`);
                    await ref.update({ jsEngageCount: tier === 3 ? getFirestoreDeleteField() : count });
                }
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const populateSurveyFields = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all surveys
        const list = [];
        const surveysQuery = db.collection('surveys');

        const collectionSnapshot = await surveysQuery.get();
        collectionSnapshot.forEach(doc => {
            list.push(convertFirebaseTimestampsToDate({ ...doc.data(), uid: doc.id, ref: doc.ref }, ['createDt', 'emailDt', 'updateDt']));
        });

        // populate surveys updateDt
        await Promise.all(
            _map(list, async survey => {
                // const uid = survey.uid
                const ref = survey.ref;
                // const emailDt = survey.emailDt;
                // if (!survey.updateDt) {
                //     const newUpdateDt = emailDt ? addDays(emailDt, 1) : new Date();
                //     await ref.update({ updateDt: newUpdateDt });
                // }
                // if (!survey.continueUse) {
                //     await ref.update({ updateDt: getFirestoreDeleteField() });
                // }
                const createDt = survey.createDt;
                if (survey.continueUse) {
                    await ref.update({ updateDt: addDays(createDt, 30) });
                }
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const generateMonthHiredCandidates = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all jobHiredCandidates
        const list = [];
        const jobHiredCandidatesQuery = db.collection('jobHiredCandidates');

        const jobHiredCandidatesQuerySnapshot = await jobHiredCandidatesQuery.get();
        jobHiredCandidatesQuerySnapshot.forEach(doc => {
            list.push(convertFirebaseTimestampsToDate({ ...doc.data(), uid: doc.id, ref: doc.ref }, ['createDt', 'updateDt']));
        });

        // create monthHiredCandidates
        await Promise.all(
            _map(list, async jobHiredCandidate => {
                const jobId = jobHiredCandidate.uid;
                const createDt = jobHiredCandidate.createDt || new Date();
                const month = getStatsDocIdByDt(createDt);
                const jsIdList = jobHiredCandidate.jsIdList;

                const jobDoc = await db.collection('jobs').doc(jobId).get();
                const jobData = jobDoc.exists ? jobDoc.data() : {};
                const { employerId, jobTitle } = jobData;

                const candidates = _map(jsIdList, jsId => ({ jsId, createDt }));

                const dto = {
                    createDt,
                    employerId,
                    jobId,
                    jobTitle,
                    candidates,
                    month,
                };

                let existingDoc = null;
                const query = db.collection('monthHiredCandidates').where('jobId', '==', jobId).where('month', '==', month).limit(1);
                const snapshot = await query.get();
                snapshot.forEach(doc => {
                    existingDoc = doc;
                });

                if (existingDoc) {
                    existingDoc.ref.update(mapDefinedFields(dto));
                } else {
                    await db.collection('monthHiredCandidates').add(mapDefinedFields(dto));
                }
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const getStatsDocIdByDt = dt => {
    // const zonedDt = utcToZonedTime(dt, 'America/New_York');
    const yearMonthStr = format(dt, 'yyyy-MM');

    return yearMonthStr;
};

export const getStatsDocIdForCurrentMonth = () => {
    const now = new Date();
    // const zonedDt = utcToZonedTime(now, 'America/New_York');
    const yearMonthStr = format(now, 'yyyy-MM');

    return yearMonthStr;
};

export const populateAppliedJobs = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all surveys
        const list = [];
        const appliedJobsQuery = db.collection('appliedJobs');

        const collectionSnapshot = await appliedJobsQuery.get();
        collectionSnapshot.forEach(doc => {
            list.push(convertFirebaseTimestampsToDate({ ...doc.data(), uid: doc.id, ref: doc.ref }, ['createDt']));
        });

        const dto = {};

        // populate appliedJobs companyName and jobTitle
        await Promise.all(
            _map(list, async appliedJob => {
                // const uid = survey.uid
                const ref = appliedJob.ref;

                // const employerId = appliedJob.employerId;
                // const employerDoc = await db.collection('employers').doc(employerId).get();
                // if (employerDoc.exists) {
                //     const employerData = employerDoc.data();
                //     _set(dto, 'companyName', employerData.companyName);
                // }

                // const jobId = appliedJob.jobId;
                // const jobDoc = await db.collection('jobs').doc(jobId).get();
                // if (jobDoc.exists) {
                //     const jobData = jobDoc.data();
                //     _set(dto, 'jobTitle', jobData.jobTitle);
                // }

                // const userId = appliedJob.userId;
                // const userDoc = await db.collection('users').doc(userId).get();
                // if (userDoc.exists) {
                //     const userData = userDoc.data();
                //     _set(dto, 'jsName', getFullNameByUser(userData));
                //     _set(dto, 'jsCountry', userData.country);
                // }

                const createDt = appliedJob.createDt;
                const month = getStatsDocIdByDt(createDt);
                _set(dto, 'month', month);

                await ref.update(mapDefinedFields(dto));
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const populateInterviews = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all surveys
        const list = [];
        const interviewsQuery = db.collection('interviews');

        const collectionSnapshot = await interviewsQuery.get();
        collectionSnapshot.forEach(doc => {
            list.push(convertFirebaseTimestampsToDate({ ...doc.data(), uid: doc.id, ref: doc.ref }, ['createDt', 'startDt', 'endDt', 'previousStartDt', 'previousEndDt']));
        });

        const dto = {};

        // populate appliedJobs companyName and jobTitle
        await Promise.all(
            _map(list, async interview => {
                // const uid = interview.uid
                const ref = interview.ref;

                const createDt = interview.createDt || interview.startDt;
                const month = getStatsDocIdByDt(createDt);
                _set(dto, 'createDt', createDt);
                _set(dto, 'month', month);

                await ref.update(mapDefinedFields(dto));
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const populateAdWidthCustomers = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all surveys
        const list = [];
        const adQuery = db.collection('ad2');

        const collectionSnapshot = await adQuery.get();
        collectionSnapshot.forEach(doc => {
            list.push(convertFirebaseTimestampsToDate({ ...doc.data(), uid: doc.id, ref: doc.ref }, ['createDt', 'holdDt', 'purchaseDt']));
        });

        const dto = {};

        // populate ad2 with adCustomers
        await Promise.all(
            _map(list, async ad => {
                // const uid = survey.uid
                const ref = ad.ref;

                const adCusId = ad.adCusId;
                const adCustomerDoc = await db.collection('adCustomers').doc(adCusId).get();
                if (adCustomerDoc.exists) {
                    const adCusData = adCustomerDoc.data();
                    _set(dto, 'companyName', adCusData.companyName);
                    _set(dto, 'email', adCusData.email);
                    _set(dto, 'phone', adCusData.phone);
                    _set(dto, 'country', adCusData.country);
                    _set(dto, 'state', adCusData.state);
                    _set(dto, 'city', adCusData.city);
                    _set(dto, 'cityLocation', adCusData.cityLocation);
                }

                await ref.update(mapDefinedFields(dto));
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const populateFeedbacks = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all surveys
        const list = [];
        const feedbackQuery = db.collection('feedback');

        const collectionSnapshot = await feedbackQuery.get();
        collectionSnapshot.forEach(doc => {
            list.push(convertFirebaseTimestampsToDate({ ...doc.data(), uid: doc.id, ref: doc.ref }, ['createDt']));
        });

        const dto = {};

        // populate feedback location fields
        await Promise.all(
            _map(list, async feedback => {
                // const uid = interview.uid
                const ref = feedback.ref;

                const employerId = feedback.employerId;
                if (employerId) {
                    const employerDoc = await db.collection('employers').doc(employerId).get();
                    if (employerDoc.exists) {
                        const employerData = employerDoc.data();
                        _set(dto, 'country', employerData.country);
                        _set(dto, 'state', employerData.state);
                        _set(dto, 'city', employerData.city);
                        _set(dto, 'cityLocation', employerData.cityLocation);
                    }

                    // const createDt = interview.createDt || interview.startDt;
                    // const month = getStatsDocIdByDt(createDt);
                    // _set(dto, 'createDt', createDt);
                    // _set(dto, 'month', month);

                    await ref.update(mapDefinedFields(dto));
                }
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const fetchCreatableLovCollection = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all
        const list = [];
        const query = db.collection('otherEducations').orderBy('name');

        const collectionSnapshot = await query.get();
        collectionSnapshot.forEach(doc => {
            // list.push(convertFirebaseTimestampsToDate({ ...doc.data(), uid: doc.id, ref: doc.ref }, []));
            const data = doc.data();
            list.push(data.name);
        });

        console.log('Creatable LOV JSON String: ', JSON.stringify({ list }));

        setSnackbarMessage('Done! See Console Log.');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const fixDashboardActionNeededPendingInterviews = async ({ setSnackbarMessage }) => {
    const db = getFirestore();
    try {
        // get all dashboards
        const list = [];
        const query = db.collection('dashboards');

        const collectionSnapshot = await query.get();
        collectionSnapshot.forEach(doc => {
            list.push({ ...doc.data(), uid: doc.id, ref: doc.ref });
        });

        // const dto = {};

        // for each dashboard actionNeededPendingInterviews, remove interview id if the interview is CONFIRMED or DENIED
        await Promise.all(
            _map(list, async dashboard => {
                const ref = dashboard.ref;
                let isRemoveId = false;

                const actionNeededPendingInterviews = dashboard.actionNeededPendingInterviews;

                await Promise.all(
                    _map(actionNeededPendingInterviews, async interviewId => {
                        const interviewRef = db.collection('interviews').doc(interviewId);
                        const interviewDoc = await interviewRef.get();
                        if (interviewDoc.exists) {
                            const interviewData = interviewDoc.data();
                            const status = interviewData?.status;
                            isRemoveId = status === 'CONFIRMED' || status === 'DENIED';
                        }

                        if (isRemoveId) {
                            console.log(`Removing ${interviewId} from dashboard '${dashboard.uid}' actionNeededPendingInterviews array...`);
                            await ref.update({ actionNeededInterviewCount: getFirestoreIncrementField(-1), actionNeededPendingInterviews: getArrayRemove(interviewId) });
                        }
                    }),
                );
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};

export const sendWaitListEmails = async ({ setSnackbarMessage }) => {
    const db = getFirestore();

    const functions = getCloudFunctions();
    const sendWaitListEmails = functions.httpsCallable('sendWaitListEmails');

    const jsList = [];
    const empList = [];

    try {
        // get all dashboards
        // const list = [];
        const query = db.collection('waitList');

        const collectionSnapshot = await query.get();
        collectionSnapshot.forEach(doc => {
            // list.push({ ...doc.data(), uid: doc.id, ref: doc.ref });
            const waitList = doc.data();
            const firstName = waitList.firstName;
            const email = waitList.email;
            const userType = waitList.userType;

            if (userType === 'EMP') empList.push({ email, firstName });
            else jsList.push({ email, firstName });
        });

        // const dto = {};

        // const jsList = [{ email: 'mr.eddieliu+test.waitlist7@gmail.com' }, { email: 'kfrancis@yourworld.me' }, { email: 'dbarb79@gmail.com' }];
        // const empList = [{ email: 'mr.eddieliu+test.waitlist8@gmail.com' }, { email: 'kfrancis@yourworld.me' }, { email: 'dbarb79@gmail.com' }];
        // const jsList = [{ email: 'mr.eddieliu+test.waitlist7@gmail.com' }, { email: 'eidde.com+test.waitlist3@gmail.com' }];
        // const empList = [{ email: 'mr.eddieliu+test.waitlist4@gmail.com' }, { email: 'eidde.com+test.waitlist4@gmail.com' }];

        await Promise.all(
            _map(empList, async recipient => {
                await sendWaitListEmails({ to: recipient.email, type: 'EMP' });
            }),
        );

        await Promise.all(
            _map(jsList, async recipient => {
                await sendWaitListEmails({ to: recipient.email, type: 'JS' });
            }),
        );

        setSnackbarMessage('Done');
    } catch (error) {
        console.log('Error:', error);
    }
};
